// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3Ko2x","icon":"style_icon__T5E_G","badge":"style_badge__JR5Vc"};